import React from "react";
import { LearningRecordSimulation, SimulationAssessmentReport, SimulationTranscript } from "src/types/coaching/learners";

export interface SimulationContextProps {
  id?: string;

  view: "summary" | "device_setup" | "simulator" | 'completion' | "report" | "failed" | "call-recording";
  secondaryView?: null | "call-recording" | "call-recording-minimized";
  startingSimulation?: boolean;
  enrollingSimulation?: boolean;
  endingSimulation?: boolean;
  restartingSimulation?: boolean;
  retakingSimulation?: boolean;

  fetchingReport?: boolean;
  fetchedReport?: boolean;

  assessmentReport?: SimulationAssessmentReport;

  fetchingTranscripts?: boolean;
  fetchedTranscripts?: boolean;

  transcripts?: SimulationTranscript[];

  // eslint-disable-next-line no-unused-vars
  changeView? : (view: "summary" | "device_setup" | "simulator" | 'completion' | "report" | "failed") => void;

  // eslint-disable-next-line no-unused-vars
  changeSecondaryView? : (view: null | "call-recording" | "call-recording-minimized") => void;

  enrollSimulation?: () => void;
  startSimulation?: () => void;
  retakeSimulation?: () => void;
  restartSimulation?: () => void;
  resumeSimulation?: () => void;
  // eslint-disable-next-line no-unused-vars
  endSimulation?: (simulation: LearningRecordSimulation) => void;

  viewReport?: (attemptId?: string) => void;
  fetchTranscripts?: () => void;

  // eslint-disable-next-line no-unused-vars
  onBack?: () => void;

  devices?: {
    audioInputs: MediaDeviceInfo[];
    audioOutputs: MediaDeviceInfo[];
    videoInputs: MediaDeviceInfo[];
  };
  selectedDevices?: {
    audioInput: string;
    audioOutput: string;
    videoInput: string;
  };
  // eslint-disable-next-line no-unused-vars
  setDevices?: (devices: { audioInputs: MediaDeviceInfo[]; audioOutputs: MediaDeviceInfo[]; videoInputs: MediaDeviceInfo[] }) => void;
  // eslint-disable-next-line no-unused-vars
  onDeviceChange?: (kind: "audioInput" | "audioOutput" | "videoInput", deviceId: string) => void;
  selectedAttemptId?: string;

  showLearnerAttemptsDropdown?: boolean;
}

export const SimulationContext = React.createContext<SimulationContextProps>({
  view: "summary",
  showLearnerAttemptsDropdown: true,
});